import { createAsyncThunk } from '@reduxjs/toolkit';
import { PertaminaService } from '@bvt-features/pertamina/service/pertaminService';
import { STORE_PREFIX } from '@bvt-features/pertamina/constant/STORE_PREFIX';
import { assetActions } from './asset.slice';
import { KategoriService } from '@bvt-features/genset/poi/service/kategori';
import axios from 'axios';
import { throttle } from 'lodash';

const pertaminaService = new PertaminaService();
const kategoriService = new KategoriService();

export const getListAsset = createAsyncThunk(
  `${STORE_PREFIX}/getListAsset`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.getListAsset(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailAsset = createAsyncThunk(
  `${STORE_PREFIX}/getDetailAsset`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.getDetailAsset(param);
      if (resp && param.is_history) {
        return { ...resp, data: { ...resp.data, is_history: true } };
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const doDownloadAssetList = createAsyncThunk(
  `${STORE_PREFIX}/doDownloadAssetList`,
  async (param, { rejectWithValue, dispatch }) => {
    try {
      const resp = await pertaminaService.downloadAssetList(
        param,
        (progressEvent) => {
          const total = progressEvent.total ?? 1;
          const loaded = progressEvent.loaded;

          const skippedPortion = total * 0.245;
          const adjustedTotal = total * 0.755;
          const adjustedLoaded = loaded - skippedPortion;

          const percentCompleted = Math.max(
            0,
            Math.min(100, (adjustedLoaded / adjustedTotal) * 100)
          );

          dispatch(assetActions.setDownloadTotalSize(adjustedTotal));
          dispatch(assetActions.setDownloadLoadedSize(adjustedLoaded));
          dispatch(assetActions.setDownloadProgress(percentCompleted));
        }
      );
      const base64Data = resp.file;
      const uint8Array = new Uint8Array(
        atob(base64Data)
          .split('')
          .map((char) => char.charCodeAt(0))
      );
      const blob = new Blob([uint8Array], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const filename = resp.filename;
      return { url, filename };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUpdateAsset = createAsyncThunk(
  `${STORE_PREFIX}/createUpdateAsset`,
  async (param, { rejectWithValue }) => {
    try {
      return await pertaminaService.createUpdateAsset(param);
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

/**
 * @param {string} param
 */
export const doDeleteAsset = createAsyncThunk(
  `${STORE_PREFIX}/doDeleteAsset`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.deleteAsset(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * @param {object} param
 * @param {string} param.area_ruko_id
 * @param {boolean} param.is_history
 * @param {string} param.period
 */

export const getRukoListDetail = createAsyncThunk(
  `${STORE_PREFIX}/getRukoListDetail`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.getRukoList(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * @param {object} param
 * @param {string} param.area_tenant_id
 * @param {boolean} param.is_history
 * @param {string} param.period
 */
export const getTenantListDetail = createAsyncThunk(
  `${STORE_PREFIX}/getTenantListDetail`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.getTenantList(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * @param {object} param
 * @param {string} param.area_poi_id
 * @param {boolean} param.is_history
 * @param {string} param.period
 */
export const getPOIListDetail = createAsyncThunk(
  `${STORE_PREFIX}/getPOIListDetail`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.getPOIList(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatusAnalysisAsset = createAsyncThunk(
  `${STORE_PREFIX}/getStatusAnalysisAsset`,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.getStatusAsset();
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getKategoriList = createAsyncThunk(
  `${STORE_PREFIX}/getKategoriList`,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await kategoriService.getAll();
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getNewTenantList = createAsyncThunk(
  `${STORE_PREFIX}/getNewTenantList`,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.getNewTenantList();
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeNewTenant = createAsyncThunk(
  `${STORE_PREFIX}/removeNewTenant`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.removeNewTenant(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createNewTenant = createAsyncThunk(
  `${STORE_PREFIX}/createNewTenant`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.cerateNewTenants(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const bulkDownloadResult = createAsyncThunk(
  `${STORE_PREFIX}/bulkDownloadResult`,
  async (param, { rejectWithValue, dispatch }) => {
    try {
      let isComplate = false;

      if (param?.status === 'error') {
        throw { message: param.message };
      }

      const throttledProgress = throttle((loaded, total) => {
        const progress = Math.round((loaded / total) * 100);
        dispatch(assetActions.setDownloadTotalSize(total));
        dispatch(assetActions.setDownloadLoadedSize(loaded));
        dispatch(assetActions.setDownloadProgress(progress));
      }, 500);

      const resp = await axios.get(param.url, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          if (isComplate) {
            return;
          }

          throttledProgress(progressEvent.loaded, progressEvent.total ?? 1);
        },
      });

      isComplate = true;
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      return { url, filename: param.filename };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const doDownloadBulkResultXls = createAsyncThunk(
  `${STORE_PREFIX}/doDownloadBulkResultXls`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.doBulkDownloadResultXls(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * @param {string} param
 */

export const getHistoryList = createAsyncThunk(
  `${STORE_PREFIX}/getHistoryList`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.getListHistory(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const doDownloadBulkPDF = createAsyncThunk(
  `${STORE_PREFIX}/doDownloadBulkResultPDF`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await pertaminaService.doBulkDownloadPDF(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
